import { Component, OnInit } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'
import { SpinnerService } from '../services/spinner.service'
import { ClientApprovalsService } from '../services/client-approvals.service'
import { take } from 'rxjs/operators'
import { ClientApproval } from '../models/client-approval'

@Component({
  selector: 'app-apps-page',
  templateUrl: './apps-page.component.html'
})
export class AppsPageComponent implements OnInit {

  public loaded = false
  public clientApprovals: ClientApproval[] = []

  constructor(
    private translate: TranslateService,
    private spinnerService: SpinnerService,
    private clientApprovalsService: ClientApprovalsService
  ) {
    // noop
  }

  public ngOnInit(): void {
    this.spinnerService.start()
    this.loadClientApprovals()
  }

  public loadClientApprovals(): void {
    this.clientApprovalsService.findAll().pipe(take(1)).subscribe((val) => {
      val.forEach((ca) => {
        if(ca.approved === true){
          this.clientApprovals.push(ca)
        }
      })
      this.setInitialLoadStatus()
    })
  }

  public removeClient(id: number): void {
    this.clientApprovalsService.destroy(id).pipe(take(1)).subscribe((v)=> {
      this.clientApprovals = this.clientApprovals.filter((c) => c.id !== id)
    })
  }

  public setInitialLoadStatus(): void {
    this.loaded = !!this.clientApprovals
    if (this.loaded) {
      this.spinnerService.stop()
    }
  }
}

